import React, { Component } from 'react'
import Create from '../../crud/create'
import createFields from './create-fields'
import menuItems from './menuItems'
import api from '../../../api'

class CreateSessionReservation extends Component<any, any> {
  constructor (props) {
    super(props)
    this.state = {}
  }

  componentDidMount () {
    const { sessionSaleId } = this.props.params
    api.get(`admin/session_sales/${sessionSaleId}`)
      .then(res => res.json())
      .then(sessionSale => this.setState({ sessionSale }))
  }

  render () {
    const { sessionSale } = this.state
    if (!sessionSale) return null

    return (
      <Create
// @ts-ignore
        title='Create Session Reservation'
        fields={createFields(sessionSale)}
        apiPath='admin/session_reservations'
        successRedirectPath={resource => {
          return `/events/session-sales/${sessionSale.id}/reservations/${resource.id}/edit`
        }}
        buildMenuItems={menuItems}
        resource={{
          session_sale_id: sessionSale.id
        }}
      />
    )
  }
}

export default CreateSessionReservation
